// Distress signal filter helpers — keep label/order in sync with backend market_engine.DISTRESS_SIGNALS.

export const DISTRESS_SIGNALS = [
  { id: "pre_foreclosure", label: "Pre-foreclosure" },
  { id: "recent_eviction", label: "Eviction" },
  { id: "involuntary_lien", label: "Involuntary lien" },
  { id: "tax_delinquent", label: "Tax delinquent" },
  { id: "code_violation", label: "Code violation" },
  { id: "absentee_owner", label: "Absentee owner" },
  { id: "vacant", label: "Vacant" },
  { id: "probate", label: "Probate" },
  { id: "high_equity", label: "High equity" },
  { id: "long_term_owner", label: "Long-term owner" },
];

const LABEL_BY_ID = Object.fromEntries(DISTRESS_SIGNALS.map((s) => [s.id, s.label]));
export const signalLabel = (id) => LABEL_BY_ID[id] || id;

// Property matches if it has AT LEAST ONE of the selected signals (OR logic).
export function filterBySignals(properties, selectedIds) {
  if (!selectedIds || selectedIds.length === 0) return properties;
  const wanted = new Set(selectedIds);
  return properties.filter((p) => {
    const have = p.distress_signals || [];
    return have.some((s) => wanted.has(s));
  });
}
